import $ from 'jquery'
window.jQuery = $
import './libs/debounce'
import { websiteController } from "./AtriaThemeScripts/websiteController";

$(document).ready(() => {
  window.websiteController = websiteController($)
})